
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface AdvisoryOption {
  service: string;
  included: string[];
  engagement: string;
}

const AdvisoryOptions = () => {
  const advisoryOptions: AdvisoryOption[] = [
    {
      service: "Free Advisory Session",
      included: [
        "60-minute live consultation",
        "Firm AI readiness review",
        "Tactical recommendations",
        "No obligation to continue"
      ],
      engagement: "One-time"
    },
    {
      service: "Single Hour of Expert Advisory",
      included: [
        "60-minute private session",
        "Live tactical support",
        "Follow-up notes if needed"
      ],
      engagement: "One-time"
    },
    {
      service: "Standard Advisory Retainer",
      included: [
        "Up to 4 hours live support per month",
        "Email support (24-hour response)",
        "Priority scheduling"
      ],
      engagement: "Month-to-Month"
    },
    {
      service: "Premium Advisory Retainer",
      included: [
        "Up to 8 hours live support per month",
        "Document review and coaching",
        "Priority scheduling and faster email support"
      ],
      engagement: "Month-to-Month"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white/5 border-t border-b border-white/10">
      <div className="container mx-auto px-6">
        <div className="mb-12 max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Flexible Advisory Options to Fit Your Goals
          </h2>
          <p className="text-lg text-white/70">
            When your firm is ready to move forward with AI, the right support can make all the difference. Our advisory options are designed to meet you where you are — providing practical guidance, trusted expertise, and flexible support that helps your firm grow with confidence.
          </p>
        </div>

        {/* Table for Desktop */}
        <div className="hidden md:block rounded-lg overflow-hidden border border-white/10 bg-white/5 backdrop-blur">
          <Table>
            <TableHeader>
              <TableRow className="bg-white/5 border-b border-white/10">
                <TableHead className="text-white font-medium text-lg w-1/3">Service</TableHead>
                <TableHead className="text-white font-medium text-lg w-1/2">What's Included</TableHead>
                <TableHead className="text-white font-medium text-lg">Engagement Length</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {advisoryOptions.map((option, index) => (
                <TableRow key={index} className="border-b border-white/10 hover:bg-white/5">
                  <TableCell className="font-semibold">{option.service}</TableCell>
                  <TableCell>
                    <ul className="list-disc pl-5 space-y-1">
                      {option.included.map((item, idx) => (
                        <li key={idx} className="text-white/80">{item}</li>
                      ))}
                    </ul>
                  </TableCell>
                  <TableCell>{option.engagement}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        {/* Cards for Mobile */}
        <div className="md:hidden space-y-6">
          {advisoryOptions.map((option, index) => (
            <Card key={index} className="bg-white/5 border-white/10">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-4">{option.service}</h3>
                <div>
                  <h4 className="font-medium text-white/70 mb-2">What's Included</h4>
                  <ul className="list-disc pl-5 space-y-1 mb-4">
                    {option.included.map((item, idx) => (
                      <li key={idx} className="text-white/80">{item}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium text-white/70 mb-2">Engagement Length</h4>
                  <p>{option.engagement}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvisoryOptions;
